import React from "react";
import Modal from "../../../components/Reusable/Modal";

interface DeleteSupportModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isDeleting: boolean;
  question?: string;
}

const DeleteSupportModal: React.FC<DeleteSupportModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isDeleting,
  question,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} className="w-full max-w-md">
      <div className="text-center space-y-4 pt-2">
        <div className="flex items-center justify-center w-12 h-12 mx-auto rounded-full bg-[#FEF3F2]">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 6H5H21" stroke="#D92D20" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z" stroke="#D92D20" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <h2 className="text-lg font-semibold text-gray-800 dark:text-white">
          Delete Support Item
        </h2>
        {question && (
          <p className="text-sm text-gray-500 dark:text-gray-400 px-4">
            Are you sure you want to delete{" "}
            <span className="font-medium text-gray-700 dark:text-gray-300">
              "{question}"
            </span>
            ? This action cannot be undone.
          </p>
        )}
        {!question && (
          <p className="text-sm text-gray-500 dark:text-gray-400">
            Are you sure you want to delete this support item? This action cannot be undone.
          </p>
        )}
        <div className="flex justify-center gap-3 pt-2">
          <button
            type="button"
            onClick={onClose}
            disabled={isDeleting}
            className="px-4 py-2 border border-[#D0D5DD] dark:border-[#FFFFFF1A] rounded-lg text-sm font-medium dark:text-white disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={isDeleting}
            className="px-4 py-2 bg-red-600 text-white rounded-lg text-sm font-medium disabled:opacity-70"
          >
            {isDeleting ? "Deleting..." : "Yes, Delete"}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteSupportModal;
